'use client';
import dynamic from 'next/dynamic';
import IconListUS from './comp/IconListUS';

const IconListKR = dynamic(() => import('./comp/IconListKR'), {
    ssr: false,
});
const IconListCN = dynamic(() => import('./comp/IconListCN'), {
    ssr: false,
});
const IconListRU = dynamic(() => import('./comp/IconListRU'), {
    ssr: false,
});
const IconListZa = dynamic(() => import('./comp/IconListZa'), {
    ssr: false,
});
const IconListAU = dynamic(() => import('./comp/IconListAU'), {
    ssr: false,
});
const IconListMX = dynamic(() => import('./comp/IconListMX'), {
    ssr: false,
});

export const getFooterIconList = (locale: string) => {
    switch (locale) {
        case 'cn':
            return IconListCN;
        case 'kr':
            return IconListKR;
        case 'cis':
            return IconListRU;
        case 'za':
            return IconListZa;
        case 'au':
            return IconListAU;
        case 'mx':
            return IconListMX;
        default:
            return IconListUS;
    }
};
